import { create } from 'zustand'

let closePanelTimer = null

export const useSceneStore = create((set, get) => ({
  layout: 'focus',
  panel: null,
  panelMode: 'login',
  panelPayload: {},
  panelDismissed: {},
  transition: 'idle',
  landingDismissed: false,
  flickTrigger: 0,

  openPanel: (panel, options = {}) => {
    if (closePanelTimer) {
      clearTimeout(closePanelTimer)
      closePanelTimer = null
    }
    const { mode, payload = {} } = options
    const panelDismissed = { ...get().panelDismissed }
    if (panel) panelDismissed[panel] = false
    set({
      panel,
      layout: panel && panel !== 'landing' ? 'panel' : 'focus',
      panelMode: mode || get().panelMode,
      panelPayload: payload,
      panelDismissed,
      transition: 'panelIn',
      flickTrigger: get().flickTrigger + 1,
    })
    setTimeout(() => set({ transition: 'idle' }), 420)
  },

  closePanel: () => {
    if (closePanelTimer) clearTimeout(closePanelTimer)
    set({ transition: 'panelOut' })
    closePanelTimer = setTimeout(() => {
      closePanelTimer = null
      set({
        panel: null,
        layout: 'focus',
        panelPayload: {},
        transition: 'idle',
      })
    }, 380)
  },

  dismissPanel: (panel) => {
    if (!panel) {
      get().closePanel()
      return
    }
    if (closePanelTimer) clearTimeout(closePanelTimer)
    set((state) => ({
      transition: 'panelOut',
      panelDismissed: { ...state.panelDismissed, [panel]: true },
    }))
    closePanelTimer = setTimeout(() => {
      closePanelTimer = null
      set({
        panel: null,
        layout: 'focus',
        panelPayload: {},
        transition: 'idle',
      })
    }, 380)
  },

  resetPanelDismissed: (panel) => {
    set((state) => ({
      panelDismissed: { ...state.panelDismissed, [panel]: false },
    }))
  },

  setPanelMode: (panelMode) => set({ panelMode }),

  dismissLanding: () => set({ landingDismissed: true, panel: null, layout: 'focus' }),

  showLanding: () => set({ panel: 'landing', layout: 'focus' }),
}))

export function openAuthPanel(mode = 'login', payload = {}) {
  useSceneStore.getState().openPanel('auth', { mode, payload })
}
